import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login/login.component';
import { LoginModule } from './login/login.module';
import { CommonDialogComponent } from './shared/components/common-dialog/common-dialog.component';
import { NotificationComponent } from './shared/components/notification/notification.component';
import { environment } from 'src/environments/environment';
import { BoltSidenavModule } from './layout/bolt-sidenav/bolt-sidenav.module';
import { LayoutModule } from '../app/layout/layout/layout.module';
import { NumbersOnlyDirective } from './shared/directives/numbers-only.directive';
import { PhoneNumberValiationService } from './shared/services/phone-number-valiation.service';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { CreateDietPlanComponent } from './screens/create-diet-plan/create-diet-plan.component';
import { DietQuestionnaireComponent } from './screens/diet-questionnaire/diet-questionnaire.component';
import { TimePickerComponent } from './shared/components/time-picker/time-picker.component';
import { ClientProfileComponent } from './screens/client-profile/client-profile.component';
import { CreateDietPlanModule } from './screens/create-diet-plan/create-diet-plan.module';
import { DietPlanComponent } from './screens/create-diet-plan/diet-plan/diet-plan.component';
import { RootMaterialModule } from './shared/modules/root-material.module';
import { FileUploadComponent } from './shared/components/file-upload/file-upload.component';
import { DashboardModule } from './screens/dashboard/dashboard.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppointmentComponent } from './screens/appointment/appointment.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'layout',
    loadChildren: () =>
      import('../app/layout/layout/layout.module').then((m) => m.LayoutModule),
  },
];

@NgModule({
  declarations: [
    AppComponent,
    NotificationComponent,
    CommonDialogComponent,
    NumbersOnlyDirective,
    CreateDietPlanComponent,
    DietQuestionnaireComponent,
    TimePickerComponent,
    ClientProfileComponent,
    DietPlanComponent,
    FileUploadComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes, { useHash: true }),
    LoginModule,
    BoltSidenavModule,
    LayoutModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    CreateDietPlanModule,
    RootMaterialModule,
    DashboardModule,
    StoreModule.forRoot({}, {}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
  ],
  exports: [
    NotificationComponent,
    CommonDialogComponent,
    DietPlanComponent,
    FileUploadComponent,
  ],
  providers: [
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 5000 } },
  ],
  bootstrap: [AppComponent],
  entryComponents: [CommonDialogComponent],
})
export class AppModule {}
